/* global __RDL_SW_DEBUG__ */

let isOnline = true;
const PING_INTERVAL = 10000;

/**
 * Register Service Worker
 */
export function registerServiceWorker() {
  if (checkServiceWorker()) {
    const version = 4;
    const searchParams = new URLSearchParams({
      version: version.toString(),
    });
    if (__RDL_SW_DEBUG__) {
      searchParams.set('debug', '1');
    }
    navigator.serviceWorker.register(`/service-worker.js?${searchParams.toString()}`).
        then(function(registration) {
          if (!registration.active) {
            console.log('Registration successful, but not active, scope is:',
                registration.scope);
            return;
          }
          navigator.serviceWorker.addEventListener('message', handleMessage);
          checkAppStatus();
          console.log('Registration successful, scope is:', registration.scope);
        }).
        catch(function(error) {
          console.log('Service worker registration failed, error:', error);
        });
  }
}

/**
 * Check Service Worker in navigator
 * @return {boolean}
 */
function checkServiceWorker() {
  return 'serviceWorker' in navigator;
}

/**
 * Check app status
 */
function checkAppStatus() {
  postMessage({
    action: 'check_app_status',
  });
  setTimeout(checkAppStatus, PING_INTERVAL);
}

/**
 * Post message to service worker
 * @param {object} message
 */
function postMessage(message) {
  const {controller} = navigator.serviceWorker;
  if (controller) {
    controller.postMessage(message);
  }
}

/**
 * Handle message from service worker
 * @param {MessageEvent} e
 */
function handleMessage(e) {
  const {data} = e;
  if (data.action === 'ping' && isOnline !== data.online) {
    isOnline = data.online;
    toggleNetworkState(data);
  }
}

/**
 * toggle network state
 * @param {object} params
 */
function toggleNetworkState(params) {
  const offlineMessage = document.querySelector('.offline-message');
  if (!offlineMessage) {
    return;
  }

  offlineMessage.classList.toggle('offline-message--show', !params.online);
  console.log(`Ping status: ${params.online}`);
}
